const sponsors = [
  {
    slug: "eduardo-mendoza",
    name: "Asambleista Eduardo Mendoza Palma",
    logo: `${process.env.PUBLIC_URL}/images/logoEduMendoza.jpg`,
    description: "Asambleísta por Los Ríos 🇪🇨",
    instagram: "https://www.instagram.com/eduardomendozap_/",
  },
    {
    slug: "comercial-cardenal",
    name: "Comercial Cardenal",
    logo: `${process.env.PUBLIC_URL}/images/logoCardenal.jpg`,
    description: "Compra y venta de cacao 🍫\n📍Buena Fe",
  },
  {
    slug: "granaivan",
    name: "GRANAIVAN | Snacks Naturales 🌾🇪🇨",
    logo: `${process.env.PUBLIC_URL}/images/logoGranaivan.jpg`,
    description: "🌱 Salud y bienestar en cada bocado\n🍍 Chips de piña deshidratada\n🍫 Barras de chocolate de cacao puro\n📍Buena Fe-Guayaquil",
    website: "www.granaivan.com",
    whatsapp: "https://wa.me/593989156200",
    // email: "granaivanloor@gmail.com", 
    instagram: "https://www.instagram.com/granaivanbf/",
    facebook: "https://www.facebook.com/profile.php?id=61563551713516",
    
  },
    {
    slug: "harmonyDentalCenter",
    name: "Harmony Dental Center",
    logo: `${process.env.PUBLIC_URL}/images/logo_harmony.jpg`,
    description: "Transformamos sonrisas con tecnología avanzada y un cuidado profesional que hace la diferencia 🦷✨",
    whatsapp: "https://wa.me/5930997373685",
    facebook:"https://www.facebook.com/profile.php?id=61567538613869&mibextid=ZbWKwL",
    email: "harmonydc98@gmail.com",
  },
  {
    slug: "thaigerpharmaec",
    name: "Thaiger Pharma Group",
    logo: `${process.env.PUBLIC_URL}/images/logo_thaigerpharmaec.jpg`,
    description: "💊Supplements and Nutrition💉\n🌎CEO Latinoamerica\n💪🏼Ciclos de volumen y definición",
    instagram: "https://www.instagram.com/thaigerpharmaec/",
    whatsapp: "https://wa.me/593979000044",
  },
  {
    slug: "muscleice-ec",
    name: "RAM Life Health & Fitness",
    logo: `${process.env.PUBLIC_URL}/images/logo_muscleice.jpg`,
    description: "Súper alimentos tecnológicamente diseñados para potenciar tu salud, repletos de proteína, vitaminas y minerales 💪🏼",
    instagram: "https://www.instagram.com/muscleice.ec/",
    tiktok: "https://www.tiktok.com/@muscleice.ec",
  },
   {
    slug: "klbikini_byklsports",
    name: "Kl Bikini Competition",
    logo: `${process.env.PUBLIC_URL}/images/logo_kl_bikini.jpg`,
    description: "👙Bikinis de competencia\n👠Zapatos para poses\n💍 Pulseras y aretes\n🩲 Truzas\n🩳 Bermudas men's physique",
    whatsapp: "https://wa.me/593992475895",
    instagram: "https://www.instagram.com/klbikini_byklsports/",
  },

  // {
  //   slug: "tu-marca-aqui",
  //   name: "Tu Marca Aquí",
  //   logo: `${process.env.PUBLIC_URL}/images/tumarca.png`,
  //   description: "Tu marca aquí.",
  //   facebook: "https://facebook.com/tumarcaaqui",
  //   instagram: "https://instagram.com/tumarcaaqui",
  //   website: "https://tumarcaaqui.com",
  // },
  
  
];

export default sponsors;